/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Preview_Pane_IssuesInputs */

const cs_import_preview_pane_issues = /** @type {(inputs: Import_Preview_Pane_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problémy`)
};

const en_import_preview_pane_issues = /** @type {(inputs: Import_Preview_Pane_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Import_Preview_Pane_IssuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_preview_pane_issues = /** @type {((inputs?: Import_Preview_Pane_IssuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Preview_Pane_IssuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_preview_pane_issues(inputs)
	return cs_import_preview_pane_issues(inputs)
});